module.exports = {
	init: function () {
		// GF triggers this on the page's global jQuery, not the copy bundled here
		var jq = window.jQuery;
		if (!jq) {
			return;
		}

		// Move the AJAX confirmation into the status region rendered on page load
		// (see mightily_gform_status_region in Core.php) so screen readers announce it
		jq(document).on('gform_confirmation_loaded', function (event, formId) {
			var region = document.getElementById('gform_status_' + formId);
			var confirmation = document.getElementById('gform_confirmation_wrapper_' + formId);
			if (!region || !confirmation) {
				return;
			}

			// GF calls wp.a11y.speak() on #gform_confirmation_message_{id} right after this
			// event; drop the id so it speaks nothing and the message isn't read twice
			var message = document.getElementById('gform_confirmation_message_' + formId);
			if (message) {
				message.removeAttribute('id');
			}

			// Give focus loss (the submit button is gone) and GF's scroll a moment to settle
			setTimeout(function () {
				region.appendChild(confirmation);
			}, 100);
		});
	},
};
